<template>
  <div class="canlender-child clearfix">
    <div class="canlender-date">
      <span class="date">{{canlenderInfoB.datelist.split(' ')[0]}}</span>
      <span class="week">{{canlenderInfoB.week}}</span>
      <span class="quality">{{canlenderInfoB.countdown}}</span>
    </div>
    <div class="canlender-info">
      <p><span>{{canlenderInfoB.lunarcal}}</span><span class="right">{{canlenderInfoB.festival ? canlenderInfoB.festival : ''}}</span></p>
      <p>{{canlenderInfoB.lunar_year}}</p>
      <p><span>{{canlenderInfoB.lunar_mone}}</span><span class="right">{{canlenderInfoB.lunar_day}}</span></p>
    </div>
    <div class="canlender-center">
      <div class="pic">
        <div class="pic-item" :style="{backgroundImage: 'url('+leftImg+')'}"></div>
        <div class="pic-item" :style="{backgroundImage: 'url('+rightImg+')'}"></div>
      </div>
    </div>
    <div class="canlender-ea">
      <div class="content">
        <span v-if="canlenderInfoB.easy !== null" class="left">{{'宜' + canlenderInfoB.easy}}</span>
        <span v-if="canlenderInfoB.easy !== null && canlenderInfoB.avoid !== null" class="center">|</span>
        <span v-if="canlenderInfoB.avoid !== null" class="right">{{'忌' + canlenderInfoB.avoid}}</span>
        
      </div>
    </div>
    <div class="canlender-weather">
      <p v-if="weatherInfoB.time === 0" style="text-align: center"></p>
      <div class="have-weather" v-else>
        <p>
          <span class="left weather" style="padding-right: 7px;">{{weatherCode && weatherInfoB.weather_status ? weatherCode[weatherInfoB.weather_status].chinese : '天气'}}</span>
          <span class="right">
            <i class="w-icon" v-for="(item, i) in wIcon" :key="i" :style="{backgroundImage: 'url('+item+')'}"></i>
          </span>
        </p>
        <p>
          <span class="left">当前气温:</span>
          <span class="right">{{weatherInfoB.temperature + '℃'}}</span>
        </p>
        <p>
          <span class="left">空气质量:</span>
          <span class="right">{{quality && (typeof weatherInfoB.air_quality == 'number') ? quality[weatherInfoB.air_quality+''].qualityStr : ''}}</span>
        </p>
      </div>
    </div>
    <div class="canlender-icons">
      <div class="tomato">
        <span class="icon" :style="{backgroundImage: 'url('+tomatoUrl+')'}"></span>
      </div>
      <div class="icon-bottom">
        <span class="f-r icon drink" :style="{backgroundImage: 'url('+drinkUrl+')'}" v-if="canlenderInfoB.drink_on"></span>
        <span class="f-r icon pill" :style="{backgroundImage: 'url('+pillUrl+')'}" v-if="canlenderInfoB.cure_on"></span>
      </div>
    </div>
    <span class="name">秒秒测</span>
  </div>
</template>
<script>
import axios from 'axios'
import Common from '../../../assets/js/common.js'
export default {
  name: 'MmcDefault',
  props: {
    canlenderInfo: Object,
    weatherInfo: Object
  },
  data () {
    return {
      canlenderInfoB: this.canlenderInfo,
      weatherInfoB: this.weatherInfo,
      weatherCode: null,
      quality: null,
      leftImg: '',
      rightImg: '',
      wIcon: [],
      tomatoUrl: Common.staticHref() + 'img/tomatoIcon.png',
      drinkUrl: Common.staticHref() + 'img/drinkIcon.png',
      pillUrl: Common.staticHref() + 'img/pillIcon.png',
      leftShow: true,
      rightShow: false
    }
  },
  watch: {
    canlenderInfo (newValue) {
      if (!newValue) return
      this.canlenderInfoB = newValue
      this.computedImgsrc()
    },
    weatherInfo (newValue) {
      if (!newValue) return
      this.weatherInfoB = newValue
      this.weatherIcon()
    }
  },
  methods: {
    getWeatherCode () {
      axios.get(Common.staticHref() + 'mock/weather.json')
      .then(this.getWeatherCodeSucc)
      .catch(this.getWeatherCodeError)
    },
    getWeatherCodeSucc (res) {
      if (!res.data) return
      this.weatherCode = res.data
      this.weatherIcon()
    },
    getWeatherCodeError (error) {
      console.log(error)
    },
    getQuality () {
      axios.get(Common.staticHref() + 'mock/quality.json')
      .then(this.getQualitySucc)
      .catch(this.getQualityErr)
    },
    getQualitySucc (res) {
      if (!res.data) return
      this.quality = res.data
    },
    getQualityErr (error) {
      console.log(error)
    },
    computedImgsrc () {
      let date = this.canlenderInfoB.datelist.split(' ')[0]
      if (!(date.indexOf('-') > -1)) return
      let dateArr = date.split('-')
      let dateLen = dateArr.length
      if (dateLen !== 3) return
      let day = parseInt(dateArr[2])
      let leftCode = Math.floor(day / 10)
      let rightCode = day % 10
      let CommonSrc = Common.staticHref()
      this.leftImg = CommonSrc + 'img/dateNumber/' + leftCode + '@2x.png'
      this.rightImg = CommonSrc + 'img/dateNumber/' + rightCode + '@2x.png'
    },
    weatherIcon () {
      this.wIcon.splice(0, this.wIcon.length) // 清空数组
      if (!this.weatherCode) return
      if (!this.weatherCode[this.weatherInfoB.weather_status + '']) return false
      // if (typeof this.weatherInfoB.weather_status !== 'number') this.wIcon.push(this.createwImgSrc('NA'))
      let iconName = this.weatherCode[this.weatherInfoB.weather_status + ''].iconname
      if (iconName.indexOf('&') > -1) {
        let iconArr = iconName.split('&')
        if (iconArr.length > 0) {
          iconArr.forEach((elem, i) => {
            this.wIcon.push(this.createwImgSrc(elem))
          })
        }
      } else {
        this.wIcon.push(this.createwImgSrc(iconName))
      }
    },
    createwImgSrc (name) {
      let commonSrc = Common.staticHref() + 'img/weatherIcon/' + name + '@2x.png'
      return commonSrc
    }
  },
  created () {
    this.getWeatherCode()
    this.getQuality()
    this.computedImgsrc()
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl'
.canlender-child
  width 100%
  height 100%
  box-sizing border-box
  border 1px solid #000000
  padding 18px 14px 0
  position relative
  span
    display inline-block
  .canlender-date
    rowCenter()
    .date
      font-size 18px
      font-weight 600
    .week,.quality
      font-size 16px
      font-weight 600
      padding 0 6px
    .quality
      font-size 16px
      border-left 2px solid #000000
  .canlender-info
    padding-top 5px
    font-size 13.5px
    line-height 18px
    .right
      padding-left 9px
  .canlender-center
    padding-top 20px
    .pic
      height 100px
      width 134px
      margin 0 auto
      colCenter()
      .pic-item
        width 50%
        height 100%
        background-position center center
        background-repeat no-repeat
        background-size contain
  .canlender-ea
    padding-top 20px
    position relative
    float left 
    left 50%
    .content
      position relative
      left -50%
      height 34px
      line-height 34px
      border-bottom 6px solid #000000
      span
        display inline-block
        font-size 18px
        font-color #000000
        font-weight 600
        box-sizing border-box
      .center
        font-family '微软雅黑'
  .canlender-weather
    // float left
    margin-top 70px
    font-size 17px
    line-height 22px
    text-align center
    span
      font-weight 600
    .right
      padding-left 7px
    .have-weather
      p
        colCenter()
        span
          display inline-block
        .left
          width 160px
          text-align left
          padding-left 80px
          box-sizing border-box
        .right
          padding-left 0
        .weather
          width auto
        .right
          flex 1
          text-align left
      .w-icon
        display inline-block
        width 18px
        height 18px
        background-position center center
        background-repeat no-repeat
        background-size contain
  .canlender-icons
    position absolute
    top 20px
    right 16px
    .tomato
      rowCenter()
    .icon-bottom
      padding-top 8px
    .icon
      display inline-block
      width 16px
      height 16px
      background-position center center
      background-repeat no-repeat
      background-size contain
    span
      font-size 16px
      margin-left 8px
  .name
    position absolute
    bottom 20px
    right 21px
    font-size 13px
    color #afafaf
</style>


// WEBPACK FOOTER //
// src/canlender/StyleCommponent/MmcDefault/MmcDefault.vue